import React from "react";
import "./Cards.css";
const Card2 = ({ image, heading, description, links, backgroundColor }) => {
  return (
    <div className="card__two_wrap" style={{ background: backgroundColor }}>
      <div className="card__two_header">
        <img src={image} className="card__two_headerimg" alt="" />
      </div>
      <div className="card__two_heading">{heading}</div>
      <div className="card__two_description">{description}</div>
      {links?.length > 0 && (
        <div className="card__two_links">
          {links?.map((link) => (
            <a href={link.url} className="card__two_link">
              {link.text}
            </a>
          ))}
        </div>
      )}
    </div>
  );
};

export default Card2;
